import {CSSProperties, FC} from 'react';


export interface IIconToolsBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconToolsBmw: FC<IIconToolsBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M20 10.516h-2.465c-1.086 0-1.967-.868-1.967-1.94 0-1.07.881-1.939 1.967-1.939H20V5.624C19.508 4.634 18.069 4 16.677 4a4.343 4.343 0 0 0-4.365 4.364c0 .308.063.61.125.9L4.5 17.104a1.68 1.68 0 0 0 .008 2.399c.336.331.78.497 1.22.497.441 0 .883-.166 1.22-.497l7.532-7.425c.675.409 1.347.65 2.197.65 1.392 0 2.83-.634 3.323-1.624v-.588Z" clipRule="evenodd" />
        </svg>
    );
};
